import { ActionContext, ActionTree, GetterTree } from "vuex";

const initialState: any = {
  menu: []
};

const actions: ActionTree<any, any> = {
  setState({ commit }: ActionContext<any, any>, payload: any): void {
    commit("setState", payload);
  },
  clearState({ commit }: ActionContext<any, any>): void {
    commit("clearState");
  }
};

const mutations = {
  setState(state: any, payload: any) {
    state.menu = payload;
  },
  clearState(state: any) {
    Object.assign(state, { ...initialState });
  }
};

const getters: GetterTree<any, any> = {
  title: (state: any) => (routeName: string) => {
    const item =  state.menu.find((e: any) => e.route == routeName);
    if(item) {
        return item.adminMenuNm;
    }
    return "";
  }
};

const namespaced: boolean = true;
export default {
  namespaced,
  state: { ...initialState },
  getters,
  actions,
  mutations
};
